import React from "react";
import styled from "styled-components";
import Button from "../../buttons";
import InfinityList from "../../tables/InfinityList"
import GraphLiveMessage from "./components/GraphLiveMessage";
import GraphSubscriptionListItem from "./components/GraphSubscriptionListItem";
import LoadingMessage from "../../loaders/LoadingMessage";
import ThemedModal from "../../utilities/ThemedModal";
import { Modal } from "react-bootstrap";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { GraphLiveSubscriptionsModalProps } from "./types";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { LiveGraphSubscriptionsProvider, useLiveGraphSubscriptions } from "./hooks/LiveGraphSubscriptionsContext";

const ModalBody = styled(Modal.Body)`
    min-height: auto;
    max-height: 66.67vh;
    display: flex;
    flex-direction: column;
    padding: 0;
`;

const LiveGraphSubscriptionsModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "lg",
    userIds,
    ...rest
}: Readonly<GraphLiveSubscriptionsModalProps>) => {
    const [bodyAnimation] = useAutoAnimate();
    const {
        data,
        error,
        isLoading,
        isNextPageLoading,
        isRowLoaded,
        loadMore
    } = useLiveGraphSubscriptions();

    console.log('data', data);

    const onClose = () : void => proceed!(false);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>Live Graph Subscriptions</Modal.Title>
            </ThemedModal.Header>
            <ModalBody ref={bodyAnimation}>
                {isLoading && (
                    <LoadingMessage text="Please wait while WealthPro contacts the Microsoft Graph subscription service" />
                )}
                {!isLoading && (
                    <>
                        <GraphLiveMessage />
                        <InfinityList
                            style={{ height: '500px' }}
                            itemData={data}
                            enableScrollTracking={false}
                            row={GraphSubscriptionListItem}
                            error={error}
                            isLoading={isNextPageLoading}
                            isItemLoaded={isRowLoaded}
                            loadMoreItems={loadMore}
                            itemSize={64}
                            itemCount={data.length}
                        />
                    </>
                )}
            </ModalBody>
            <Modal.Footer>
                <Button variant="light" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export function openLiveGraphSubscriptionsModal(userIds: string[] | null) {
    return createConfirmation<GraphLiveSubscriptionsModalProps, any>(confirmable((props) => (
        <LiveGraphSubscriptionsProvider>
            <LiveGraphSubscriptionsModal {...props} />
        </LiveGraphSubscriptionsProvider>
    )))({
        dialogId: 'live_graph_subscriptions_modal',
        userIds
    });
}